/** Saved presentation state cannot attest that this session read canonical data. */
export function savedWorkspaceUiState(saved: unknown): Record<string, unknown> {
  if (saved === null || typeof saved !== 'object' || Array.isArray(saved)) return {};
  const {
    isSitesLoaded: _sitesLoaded,
    isReportsLoaded: _reportsLoaded,
    isReportMetadataLoaded: _metadataLoaded,
    hydratedReportSiteIds: _residentSites,
    ...ui
  } = saved as Record<string, unknown>;
  return ui;
}
